import SpamCommentCard from './SpamCommentCard';

export default SpamCommentCard;
